import React, { useEffect } from 'react';
import { ArrowLeft, CheckCircle2, AlertCircle, Plus } from 'lucide-react';

const MOMENTLISTOR = {
djupstadning: {
title: 'Djupstädning',
subtitle: 'Komplett momentlista',
color: '#1a1a2e',
sections: [
{
room: 'Generellt i alla rum',
items: [
'Dammtorkning av väggar och borttagning av spindelväv',
'Dammsugning och avtorkning av snickerier, element, fria ytor samt ovanpå garderober och skåp',
'Dammtorkning av prydnadssaker, hyllor och tavlor',
'Dammtorkning av eluttag och kontakter',
'Dammsugning av stoppade möbler',
'Dammsugning på och under mattor (om möjligt)',
'Dammtorkning av lampor',
'Torrdamning av elektronik (ej på bildskärm)',
'Putsning av speglar',
'Tömning av papperskorgar',
'Dammsugning och våttorkning av golv'
]
},
{
room: 'Kök',
items: [
'Rengöring av fläkt och fläktfilter (ej kolfilter)',
'Rengöring ovanpå skåp och hyllor',
'Ut- och invändig avtorkning av köksluckor',
'Rengöring av kyl och frys utvändigt',
'Rengöring av kakel/stänkskydd ovanför diskbänk',
'Rengöring under skåp (om möjligt) och avtorkning av socklar',
'Ut- och invändig rengöring av mikrovågsugn',
'Ut- och invändig avtorkning av diskmaskin',
'Avtorkning av det som står framme t.ex. kaffemaskin, oljor, salt och peppar',
'Invändig avtorkning av översta besticklådan',
'Ut- och invändig rengöring i skåp där sopbehållare finns',
'Tömning av sopor och avtorkning av sopkorg',
'Putsning av diskho, blandare, propp och sil'
]
},
{
room: 'Badrum',
items: [
'Rengöring av väggar och golv',
'Putsning av blandare, synliga rör och duschmunstycke',
'Avfettning och avkalkning av väggar och fogar där det är möjligt',
'Rengöring av dusch eller badkar (kund ansvarar för demontering av badkarsfront)',
'Rengöring av golvbrunn',
'Utvändig avtorkning av badrumsskåp',
'Rengöring av kran och handfat (ej vattenlås)',
'Rengöring av toalettstolen',
'Utvändig rengöring av vitvaror samt i tvättmedelsbehållaren på tvättmaskinen',
'Rengöring av filtret i torktumlaren',
'Avtorkning av flaskor som står framme'
]
},
{
room: 'Sovrum',
items: [
'Bäddning av sängar',
'Bäddat rent om nya lakan ligger framme',
'Dammtorkning/dammsugning av sänggavel/-karm'
]
},
{
room: 'Hall',
items: [
'Dammtorkning av ledstång, räcke och spjälor i trappa',
'Dammsugning och avtorkning av skoställ',
'Avtorkning av hatthylla',
'Avtorkning av proppskåp'
]
}
],
addons: [
'Fönsterputs',
'Karmtvätt',
'Invändig ugnsrengöring',
'Invändig rengöring av kylskåp',
'Invändig rengöring av köksskåp och lådor',
'Balkong- och garagestädning',
'Putsning av kristallkrona',
'Putsning av mässing eller silver',
'Skinnvård av soffor',
'Strykning',
'Byte av sängkläder'
],
tips: [
'För bästa städresultat rekommenderar vi att det är undanplockat i hemmet när vi kommer så vi kan fokusera på att göra rent',
'Informera oss om du har känsliga föremål eller material, t.ex. marmor i din bostad',
'Dra ut vitvaror om du vill att vi rengör bakom',
'Häng av ev. badkarsfront om du vill att vi rengör undertill',
'Av arbetsmiljöskäl lyfter/flyttar vi inte tunga möbler eller stora mattor',
'Vi dammtorkar väggar men kan inte ta bort fläckar som inte går bort med en dammtrasa',
'Vi rensar ej vattenlås under handfat och diskho',
'Vi rengör ej ugnstak i de fall det sitter värmeslingor, lampor eller annat känsligt',
'Vi tar med alla städmedel som behövs',
'Saknar du dammsugare, mopp eller hink kan vi ta med mot en kostnad',
'Vi erbjuder alltid 2 arbetsdagars garanti på vår städning'
]
},

standardstadning: {
title: 'Standardstädning',
subtitle: 'Komplett momentlista',
sections: [
{
room: 'Generellt i alla rum',
items: [
'Dammtorkning av väggar och borttagning av spindelväv',
'Dammsugning och avtorkning av snickerier, element och fria ytor',
'Dammtorkning av prydnadssaker, hyllor och tavlor',
'Dammtorkning av eluttag och kontakter',
'Dammsugning av stoppade möbler',
'Putsning av speglar',
'Tömning av papperskorgar',
'Dammsugning och våttorkning av golv'
]
},
{
room: 'Kök',
items: [
'Avtorkning av köksbänkar och luckor',
'Rengöring av diskho, blandare och sil',
'Avtorkning av kakel och stänkskydd',
'Avtorkning av det som står framme t.ex. kaffemaskin och kryddor',
'Tömning av sopor och avtorkning av sopkorg'
]
},
{
room: 'Badrum',
items: [
'Rengöring av toalettstol',
'Rengöring av handfat och kran',
'Rengöring av dusch eller badkar',
'Putsning av blandare och kranar',
'Avtorkning av alla ytor och speglar',
'Dammsugning och våttorkning av golv'
]
},
{
room: 'Sovrum',
items: [
'Dammtorkning av alla ytor',
'Bäddning av sängar (om lakan ligger framme)',
'Dammsugning och våttorkning av golv'
]
},
{
room: 'Hall',
items: [
'Dammsugning och avtorkning av skoställ',
'Avtorkning av hatthylla',
'Dammsugning och våttorkning av golv'
]
}
],
addons: [
'Fönsterputs',
'Karmtvätt',
'Invändig ugnsrengöring',
'Invändig rengöring av kylskåp',
'Invändig rengöring av köksskåp och lådor',
'Strykning',
'Byte av sängkläder'
],
tips: [
'Ha det undanplockat när vi kommer så vi kan fokusera på att göra rent',
'Informera oss om du har känsliga föremål eller material som marmor',
'Av arbetsmiljöskäl lyfter/flyttar vi inte tunga möbler',
'Vi tar med alla städmedel som behövs',
'Saknar du dammsugare, mopp eller hink kan vi ta med mot en kostnad',
'Vi erbjuder alltid 2 arbetsdagars garanti'
]
},

flyttstadning: {
title: 'Flyttstädning',
subtitle: 'Komplett momentlista',
sections: [
{
room: 'Generellt i alla rum',
items: [
'Dammtorkning av väggar, tak och borttagning av spindelväv',
'Rengöring av alla dörrar, dörrkarmar och handtag',
'Putsning av alla speglar och glaspartier',
'Rengöring av alla fönsterbrädor ut- och invändigt',
'Dammtorkning av eluttag och kontakter',
'Dammsugning och våttorkning av alla golv noggrant'
]
},
{
room: 'Kök — grundlig genomgång',
items: [
'Rengöring av fläkt och fläktfilter fullständigt (ej kolfilter)',
'Rengöring ovanpå och under alla skåp',
'Ut- och invändig avtorkning av alla köksluckor och lådor',
'Rengöring av kyl och frys ut- och invändigt (tinas vid behov)',
'Rengöring av kakel och stänkskydd',
'Rengöring av ugn och spis ut- och invändigt',
'Ut- och invändig rengöring av mikrovågsugn',
'Ut- och invändig avtorkning av diskmaskin',
'Tömning och rengöring av sopkorg',
'Putsning av diskho, blandare, propp och sil grundligt',
'Rengöring under och bakom köksskåp (om möjligt)'
]
},
{
room: 'Badrum — detaljerad rengöring',
items: [
'Avfettning och avkalkning av hela duschutrymmet',
'Rengöring och avkalkning av toalettstolen fullständigt',
'Rengöring av badkar och under front',
'Rengöring av golvbrunn och avlopp',
'Putsning av alla kranar, blandare och rör',
'Rengöring av handfat och eventuella skåp',
'Rengöring av tvättmaskin ut- och invändigt',
'Rengöring av filtret i torktumlaren',
'Skurning av golv och väggar noggrant'
]
},
{
room: 'Sovrum',
items: [
'Rengöring inuti alla garderober och skåp',
'Dammtorkning av sänggavel och -karm',
'Rengöring av fönsterbrädor och fönsterkarmar'
]
},
{
room: 'Hall & övriga utrymmen',
items: [
'Dammtorkning av ledstång, räcke och spjälor i trappa',
'Rengöring av skoställ och hatthylla',
'Rengöring av proppskåp',
'Avtorkning av entrédörr in- och utsida',
'Sopning och torkning av balkong (om möjligt)'
]
}
],
addons: [
'Fönsterputs',
'Karmtvätt',
'Balkong- och garagestädning',
'Putsning av kristallkrona',
'Putsning av mässing eller silver'
],
tips: [
'Bostaden ska vara tom på möbler och bohag vid städtillfället',
'Vi fotograferar eventuella skador INNAN städning börjar — meddela oss direkt om ni ser skador',
'Vi dokumenterar med foton före och efter för din trygghet',
'Boka minst 3 dagar i förväg för bästa planering',
'Vi rensar ej vattenlås under handfat och diskho',
'Vi rengör ej ugnstak där det sitter värmeslingor eller lampor',
'Vi tar med alla städmedel som behövs',
'Vi erbjuder 100% nöjdhetsgaranti — städar om kostnadsfritt inom 2 arbetsdagar om något inte godkänns vid besiktning'
]
},

kontorsstadning: {
title: 'Kontorsstädning',
subtitle: 'Komplett momentlista',
sections: [
{
room: 'Generellt i alla utrymmen',
items: [
'Dammtorkning av alla ytor, hyllor och möbler',
'Torrdamning av elektronik (ej bildskärmar)',
'Dammsugning och våttorkning av golv',
'Tömning av papperskorgar och sopkärl',
'Putsning av speglar och glaspartier',
'Avtorkning av dörrhandtag och kontaktytor'
]
},
{
room: 'Konferensrum och kontorsytor',
items: [
'Avtorkning av bord, stolar och fria ytor',
'Dammsugning av stoppade möbler',
'Avtorkning av fönsterbrädor',
'Rengöring av whiteboards (yttre rengöring)'
]
},
{
room: 'Kök och personalrum',
items: [
'Avtorkning av köksbänkar och luckor',
'Rengöring av diskho och blandare',
'Torkning ur mikrovågsugn',
'Avtorkning av kakel och stänkskydd',
'Tömning av sopor'
]
},
{
room: 'Toaletter och hygienutrymmen',
items: [
'Rengöring av toalettstolar fullständigt',
'Rengöring av handfat och kranar',
'Avtorkning av alla ytor',
'Påfyllning av papper och tvål (om material tillhandahålls)',
'Rengöring av golv noggrant'
]
}
],
addons: [
'Fönsterputs',
'Karmtvätt',
'Invändig ugnsrengöring',
'Storstädning av kontor (djupgående)',
'Rengöring av kylskåp',
'Städning av lager eller förråd'
],
tips: [
'Vi kan anpassa städningen helt efter era specifika behov och önskemål',
'Vi arbetar diskret och professionellt i er miljö',
'Städning kan utföras tidigt på morgonen, sent på kvällen eller på helger',
'Kontorsstädning är avdragsgill som företagskostnad',
'RUT-avdrag gäller ej för kontorsstädning',
'Vi erbjuder fasta abonnemang anpassade efter era behov'
]
},

fonsterputs: {
title: 'Fönsterputs',
subtitle: 'Komplett momentlista',
sections: [
{
room: 'Fönsterputs — vad ingår',
items: [
'Professionell putsning av alla angivna fönster',
'Vi tar med all nödvändig utrustning',
'Kan utföras även vid regn eller snö',
'Priset baseras på antal fönster och typ',
'Varje fönsterbåge (luft) räknas som ett fönster',
'Dubbelsidigt = putsning på båda sidor (insida och utsida)',
'Enkelsidigt = putsning på en sida'
]
},
{
room: 'Fönstertyper vi putsar',
items: [
'Fönster utan spröjs — från 120 kr/st (enkel) / 195 kr/st (dubbel)',
'Fönster med spröjs — från 155 kr/st (enkel) / 245 kr/st (dubbel)',
'Överhängande fönster — från 175 kr/st (enkel) / 275 kr/st (dubbel)',
'Inglasad balkong (helt) — 895 kr',
'Inglasad balkong (glasräcke) — 495 kr'
]
}
],
addons: [
'Karmtvätt — 95 kr per fönster (tvätt av fönstrets bågar och karmar)',
'Stege — 295 kr (för svåråtkomliga fönster på hög höjd)'
],
tips: [
'Ange rätt antal och typ av fönster för korrekt prissättning',
'Karmtvätt rekommenderas för bästa slutresultat',
'Vi putsar även vid dåligt väder',
'Varje fönsterbåge räknas som ett eget fönster — räkna noga för korrekt pris',
'Dubbelsidigt innebär att vi putsar både insida och utsida',
'Om stege krävs för höga fönster tillkommer 295 kr'
]
},

flytthjalp: {
title: 'Flytthjälp',
subtitle: 'Komplett momentlista',
sections: [
{
room: 'Vad ingår i flytthjälpen',
items: [
'Packning och nedpackning av bohag i lådor och kartonger',
'Bärhjälp — vi lastar och lyfter åt dig',
'Transport av möbler och lösöre till nytt hem',
'Uppackning i nytt hem om önskas',
'Demontering och montering av enklare möbler',
'Skyddstäckning av känsliga och värdefulla föremål',
'Hantering av tunga föremål som soffor, garderober och vitvaror'
]
},
{
room: 'Vad ingår INTE',
items: [
'Fordonshyra och drivmedel (tillkommer enligt offert)',
'Emballage och förpackningsmaterial (kan beställas mot tilläggskostnad)',
'Magasinering av möbler',
'Körning till återvinningscentral',
'Montering av avancerade möbelsystem som kräver specialverktyg'
]
}
],
addons: [
'Emballage och förpackningsmaterial',
'Flyttstädning av gamla bostaden',
'Städning av nya bostaden innan inflyttning',
'Montering av IKEA-möbler och liknande'
],
tips: [
'Boka i god tid — speciellt under sommaren och vid månadsskiften',
'Packa gärna lådor och kartonger i förväg för snabbare och billigare arbete',
'Informera oss om trappor, hissar och parkeringsmöjligheter vid båda adresserna',
'Märk lådorna tydligt med vilket rum de hör till i nya hemmet',
'Plocka undan personliga värdesaker och känsliga dokument själv',
'Priset faktureras per person och timme — arbetstid inkluderat'
]
},

manadspaket: {
title: 'Månadspaket',
subtitle: 'Komplett momentlista',
sections: [
{
room: 'Vecka 1 — Djupstädning (alla rum)',
items: [
'Dammtorkning av väggar och borttagning av spindelväv',
'Dammsugning och avtorkning av snickerier, element och fria ytor',
'Dammtorkning av prydnadssaker, hyllor och tavlor',
'Rengöring av fläkt och fläktfilter i kök',
'Ut- och invändig avtorkning av köksluckor',
'Rengöring av mikrovågsugn ut- och invändigt',
'Avfettning och avkalkning av fogar i badrum',
'Rengöring av golvbrunn',
'Rengöring av toalettstol, handfat och dusch/badkar',
'Bäddning av sängar',
'Dammsugning och våttorkning av alla golv'
]
},
{
room: 'Vecka 2, 3 & 4 — Standardstädning',
items: [
'Dammtorkning av alla ytor, hyllor och tavlor',
'Avtorkning av köksbänkar och luckor',
'Rengöring av diskho, blandare och sil',
'Rengöring av toalett, handfat och dusch/badkar',
'Putsning av kranar och blandare',
'Tömning av sopor och avtorkning av sopkorg',
'Bäddning av sängar',
'Dammsugning och våttorkning av alla golv'
]
}
],
addons: [
'Fönsterputs (djupstädning och/eller standardstädning)',
'Karmtvätt',
'Invändig ugnsrengöring',
'Invändig rengöring av kylskåp',
'Invändig rengöring av köksskåp och lådor',
'Strykning',
'Byte av sängkläder'
],
tips: [
'Ha det undanplockat varje städdag så vi kan fokusera på att göra rent',
'Samma städteam varje vecka för trygghet och kontinuitet',
'Faktureras månadsvis i förväg — 10 dagars betalningstid',
'Löpande avtal utan bindningstid — avsluta med en månads varsel',
'Informera oss om känsliga material som marmor eller känsliga ytor',
'Vi tar med alla städmedel som behövs',
'Saknar du dammsugare, mopp eller hink kan vi ta med mot en kostnad',
'Vi erbjuder alltid 2 arbetsdagars garanti på varje städning'
]
},

minipaket: {
title: 'Minipaket',
subtitle: 'Komplett momentlista',
sections: [
{
room: 'Varannan vecka — Djupstädning',
items: [
'Dammtorkning av väggar och borttagning av spindelväv',
'Dammsugning och avtorkning av snickerier, element och fria ytor',
'Rengöring av fläkt och fläktfilter i kök',
'Ut- och invändig avtorkning av köksluckor',
'Rengöring av mikrovågsugn ut- och invändigt',
'Avfettning och avkalkning av fogar i badrum',
'Rengöring av golvbrunn och toalettstol',
'Rengöring av handfat, dusch och badkar',
'Bäddning av sängar',
'Dammsugning och våttorkning av alla golv'
]
},
{
room: 'Varannan vecka — Standardstädning',
items: [
'Dammtorkning av alla ytor och hyllor',
'Avtorkning av köksbänkar och luckor',
'Rengöring av diskho och blandare',
'Rengöring av toalett, handfat och dusch/badkar',
'Tömning av sopor',
'Bäddning av sängar',
'Dammsugning och våttorkning av alla golv'
]
}
],
addons: [
'Fönsterputs',
'Karmtvätt',
'Invändig ugnsrengöring',
'Invändig rengöring av kylskåp',
'Strykning',
'Byte av sängkläder'
],
tips: [
'Ha det undanplockat varje städdag',
'Samma städteam varannan vecka för kontinuitet',
'Faktureras månadsvis i förväg',
'Löpande avtal utan bindningstid',
'Vi tar med alla städmedel',
'Vi erbjuder 2 arbetsdagars garanti på varje städning'
]
}
};

const MomentlistaPage = ({ service, onNavigate }) => {
useEffect(() => { window.scrollTo(0, 0); }, []);

const content = MOMENTLISTOR[service];
if (!content) return (
<div className="min-h-screen flex items-center justify-center">
<p>Momentlista hittades inte.</p>
</div>
);

return (
<div style={{ backgroundColor: '#f8f7f4', minHeight: '100vh' }}>
{/* Header */}
<div style={{ background: 'linear-gradient(135deg, #1a1a2e 0%, #0f172a 100%)', borderBottom: '4px solid #C9A84C', paddingTop: '96px' }}>
<div className="max-w-4xl mx-auto px-4 py-8">
<button onClick={() => onNavigate('home')}
className="flex items-center gap-2 mb-6 text-sm font-semibold transition-all hover:opacity-80"
style={{ color: 'rgba(255,255,255,0.6)' }}>
<ArrowLeft className="w-4 h-4" /> Tillbaka
</button>
<div className="flex items-start justify-between">
<div>
<p className="text-sm font-bold tracking-widest mb-2" style={{ color: '#C9A84C' }}>STÄDMOMENT</p>
<h1 className="text-4xl md:text-5xl font-bold text-white mb-2">{content.title}</h1>
<p style={{ color: 'rgba(255,255,255,0.6)' }}>{content.subtitle}</p>
</div>
<svg width="60" height="60" viewBox="0 0 40 40" className="flex-shrink-0 mt-2">
<circle cx="20" cy="20" r="20" fill="#C9A84C"/>
<polygon points="20,8 23.5,16 32,17 26,23 27.5,32 20,28 12.5,32 14,23 8,17 16.5,16" fill="#1a1a2e"/>
</svg>
</div>
</div>
</div>

<div className="max-w-4xl mx-auto px-4 py-12">

{/* Sections */}
<div className="space-y-8 mb-12">
{content.sections.map((section, i) => (
<div key={i} className="rounded-2xl overflow-hidden"
style={{ backgroundColor: '#fff', border: '1px solid #e8e4d9', boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
<div className="px-6 py-4" style={{ backgroundColor: '#1a1a2e', borderBottom: '3px solid #C9A84C' }}>
<h2 className="font-bold text-lg" style={{ color: '#C9A84C' }}>{section.room}</h2>
</div>
<div className="p-6">
<ul className="space-y-3">
{section.items.map((item, j) => (
<li key={j} className="flex items-start gap-3">
<CheckCircle2 className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: '#C9A84C' }} />
<span className="text-sm" style={{ color: '#333', lineHeight: '1.6' }}>{item}</span>
</li>
))}
</ul>
</div>
</div>
))}
</div>

{/* Addons */}
<div className="rounded-2xl overflow-hidden mb-8"
style={{ backgroundColor: '#fff', border: '1px solid #e8e4d9', boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
<div className="px-6 py-4" style={{ backgroundColor: '#1a1a2e', borderBottom: '3px solid #C9A84C' }}>
<h2 className="font-bold text-lg" style={{ color: '#C9A84C' }}>Tilläggstjänster</h2>
<p className="text-sm mt-1" style={{ color: 'rgba(255,255,255,0.6)' }}>Vi kan också hjälpa dig med:</p>
</div>
<div className="p-6">
<ul className="space-y-3">
{content.addons.map((addon, i) => (
<li key={i} className="flex items-start gap-3">
<Plus className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: '#C9A84C' }} />
<span className="text-sm" style={{ color: '#333', lineHeight: '1.6' }}>{addon}</span>
</li>
))}
</ul>
</div>
</div>

{/* Tips */}
<div className="rounded-2xl overflow-hidden mb-8"
style={{ backgroundColor: '#fef9ec', border: '2px solid #fde68a', boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
<div className="px-6 py-4" style={{ borderBottom: '2px solid #fde68a' }}>
<div className="flex items-center gap-3">
<AlertCircle className="w-5 h-5" style={{ color: '#92400e' }} />
<h2 className="font-bold text-lg" style={{ color: '#92400e' }}>
Att tänka på inför din {content.title}
</h2>
</div>
</div>
<div className="p-6">
<ul className="space-y-3">
{content.tips.map((tip, i) => (
<li key={i} className="flex items-start gap-3">
<span className="font-bold flex-shrink-0 mt-0.5" style={{ color: '#C9A84C' }}>•</span>
<span className="text-sm" style={{ color: '#78350f', lineHeight: '1.6' }}>{tip}</span>
</li>
))}
</ul>
</div>
</div>

{/* CTA */}
<div className="rounded-2xl p-8 text-center"
style={{ background: 'linear-gradient(135deg, #1a1a2e 0%, #0f172a 100%)', border: '1px solid rgba(201,168,76,0.3)' }}>
<h3 className="text-2xl font-bold text-white mb-3">Redo att boka?</h3>
<p className="mb-6" style={{ color: 'rgba(255,255,255,0.7)' }}>
Boka din {content.title.toLowerCase()} idag med 50% RUT-avdrag
</p>
<button onClick={() => onNavigate('booking')}
className="px-10 py-4 rounded-full font-bold text-lg transition-all hover:scale-105"
style={{ backgroundColor: '#C9A84C', color: '#1a1a2e' }}>
Boka Nu →
</button>
</div>
</div>
</div>
);
};

export default MomentlistaPage;
